import React, { useContext } from 'react';
import { useEffect, useState } from 'react';
import InputMask from 'react-input-mask';

import { useMutation, useQuery } from '@tanstack/react-query';

import { FormInstance, useForm } from 'antd/lib/form/Form';
import { FileTextOutlined, EnvironmentOutlined, PhoneOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Steps, Input, Form, Row, Col, Button, Divider, notification, Select, message, Skeleton, Popconfirm, Grid, InputNumber } from 'antd';

import { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import { SessaoContext } from '../../../Contexts/SessaoContext';
import { EnumPessoaTipo, TypePessoa } from '../../../Models/Pessoa/Pessoa';
import { FormularioDeEnderecos } from '../../../Components/Formularios/FormularioDeEnderecos';
import { EmpresaService } from '../../../Services/Pessoa/EmpresaService';
import { TypeEmpresa } from '../../../Models/Pessoa/Empresa';
import { TypeEndereco } from '../../../Models/Pessoa/Endereco';
import { TypeEmail } from '../../../Models/Pessoa/Contato/Email';
import { TypeTelefone } from '../../../Models/Pessoa/Contato/Telefone';
import { FormularioDeContatos } from '../../../Components/Formularios/FormularioDeContatos';
import { PropriedadesDoPopConfirm } from '../../../Defaults';
import { PropriedadesDeNotificacao } from '../../../Utils/Notificacoes';

import { Permissoes } from '../../../Constants/Permissoes';
import { Restrito } from '../../../Components/Restrito';

import { ResponsiveAntdTable } from "../../../Components/ResponsiveAntdTable";
import { Conjunto } from "../../../Components/Conjunto";
import { Ordenar } from "../../../Utils/Ordenacao";

import { Link, matchPath, Route, Routes, useNavigate } from "react-router-dom";
import { useRelativePath } from "../../../Hooks/useNextRelativePath";
import { useRedirection } from "../../../Hooks/useRedirection";
import { useWatchParameterOnRoutes } from "../../../Hooks/useGetParameterOnRoutes";

import AdicionarAjuda, { ITutorial } from '../../../Components/AdicionarAjuda';
import * as Tutoriais from "./empresa.tutorial"
import { Formatacoes } from '../../../Utils/Formatacao';
import EmpresaFaturamentoDrawerForm from '../../../Components/Populados/Financeiro/Faturamento/EmpresaFaturamento/EmpresaFaturamentoDrawerForm';
import InputDate from '../../../Components/Base/Input/InputDate';

// const pessoaService = new PessoaService();
const empresaService = new EmpresaService();

const FormularioDeDadosBasicosDaEmpresa: React.FC<{
    form: FormInstance<TypeEmpresa>,
    dadosIniciais?: TypeEmpresa,
    depoisDeSubmeter?: (empresa?: TypeEmpresa) => void,
}> = (props) => {

    const { dadosIniciais } = props;

    const onFinish = (values: TypeEmpresa) => {
        const emp: TypeEmpresa = {
            ...dadosIniciais,
            tipo: EnumPessoaTipo.EMPRESA,
            nome: values.nome,
            nomeSocial: values.nomeSocial,
            cnpj: values.cnpj,
            dataRegistro: values.dataRegistro && (values.dataRegistro as unknown as Dayjs).format('YYYY-MM-DD'),
            inscricaoEstadual: values.inscricaoEstadual,
            inscricaoMunicipal: values.inscricaoMunicipal,
            chavePIX: values.chavePIX
        };

        if (props.depoisDeSubmeter) props.depoisDeSubmeter(emp);
    }

    return (
        <Form
            form={props.form}
            onFinish={onFinish}
            layout='vertical'
            autoComplete='off'
        >
            <Row gutter={16} >
                <Col xs={24} md={12}>
                    <Form.Item<TypeEmpresa> name="nome" rules={[{ required: true, message: 'Por favor, informe a razão social!' }]} initialValue={dadosIniciais?.nome} label='Razão Social'>
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item<TypeEmpresa> name="nomeSocial" rules={[{ required: true, message: 'Por favor, informe o nome fantasia!' }]} initialValue={dadosIniciais?.nomeSocial} label='Nome Fantasia'>
                        <Input />
                    </Form.Item>
                </Col>
            </Row>

            <Row gutter={16}>
                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="cnpj" rules={[{ required: true, message: 'Por favor, informe o CNPJ!' }]} initialValue={dadosIniciais?.cnpj} label='CNPJ'>
                        <InputMask mask="99.999.999/9999-99">
                            <Input />
                        </InputMask>
                    </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="dataRegistro" label='Data de Registro' initialValue={dadosIniciais?.dataRegistro && dayjs(dadosIniciais!.dataRegistro!, 'YYYY-MM-DD')} getValueProps={(value) => { return value; }}>
                        <InputDate style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="inscricaoEstadual" initialValue={dadosIniciais?.inscricaoEstadual} label='Inscrição Estadual'>
                        <Input />
                    </Form.Item>
                </Col>
                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="inscricaoMunicipal" initialValue={dadosIniciais?.inscricaoMunicipal} label='Inscrição Municipal'>
                        <Input />
                    </Form.Item>
                </Col>

                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="chavePIX" initialValue={dadosIniciais?.chavePIX} label='Chave PIX'>
                        <Input placeholder='Chave PIX'/>
                    </Form.Item>
                </Col>

                <Col xs={24} md={6}>
                    <Form.Item<TypeEmpresa> name="diasParaBloqueioDeInadimplentes" initialValue={dadosIniciais?.diasParaBloqueioDeInadimplentes} label='Dias para bloqueio (inadimplentes)'>
                        <InputNumber placeholder='Dias para bloqueio (inadimplentes)' min={0} />
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
}

const ListagemDeEmpresas: React.FC<{
    aoAdicionar?: () => any;
    aoEditar?: (empresa: TypeEmpresa) => any

    hrefDoBotaoAdicionar?: string,
    hrefDoBotaoEditar?: (empresa: TypeEmpresa) => string | void
}> = (props) => {

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const tamanhoDaTela = Grid.useBreakpoint();

    const [filtro, setFiltro] = useState<TypeEmpresa>({});

    const listaEmpresas = useQuery({
        queryKey: ['listar', filtro],
        queryFn: () => empresaService.listar(filtro),
        gcTime: 0,
        enabled: true,
    });

    interface IFormFiltro {
        txtRazaoSocial?: string,
        txtNomeFantasia?: string,
        txtCnpj?: string,
        ddlAtivo?: boolean,
    }

    const onFinish = (values: IFormFiltro) => {
        const empresaFiltro: TypeEmpresa = {
            nome: values.txtRazaoSocial,
            nomeSocial: values.txtNomeFantasia,
            cnpj: values.txtCnpj && Formatacoes.sanitizar("_-/.", values.txtCnpj),
            ativo: values.ddlAtivo,
            tipo: EnumPessoaTipo.EMPRESA
        }

        setFiltro(empresaFiltro);
    }

    const adicionar = !!permissoes?.includes(Permissoes.CriarEmpresa);
    const [chavesDasLinhasExpandidas, setChavesDasLinhasExpandidas] = useState<React.Key[]>([])

    return (
        <>
            <Form<IFormFiltro> name="formListaEmpresas" autoComplete="off" onFinish={onFinish} layout="vertical">
                <Row gutter={16} id={Tutoriais.IDs.formularioDeFiltro}>
                    <Col xs={24} xl={6} id={Tutoriais.IDs.filtroDeRazaoSocial}>
                        <Form.Item<IFormFiltro> name="txtRazaoSocial" label="Razão Social">
                            <Input placeholder="Todos" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} xl={6} id={Tutoriais.IDs.filtroDeNomeFantasia}>
                        <Form.Item<IFormFiltro> name="txtNomeFantasia" label="Nome Fantasia">
                            <Input placeholder="Todos" />
                        </Form.Item>
                    </Col>
                    <Col xs={24} xl={4} id={Tutoriais.IDs.filtroDeCNPJ}>
                        <Form.Item<IFormFiltro> name="txtCnpj" label="CNPJ">
                            <InputMask mask="99.999.999/9999-99">
                                <Input placeholder="Todos" />
                            </InputMask>
                        </Form.Item>
                    </Col>
                    <Col xs={24} xl={3} id={Tutoriais.IDs.filtroDeAtivo}>
                        <Form.Item<IFormFiltro> name="ddlAtivo" label="Ativo" initialValue={true}>
                            <Select
                                allowClear
                                placeholder={"Todos"}
                                options={[
                                    { value: true, label: "Ativo" },
                                    { value: false, label: "Inativo" },
                                ]}
                            />
                        </Form.Item>
                    </Col>

                    <Col xs={adicionar ? 12 : 24} xl={adicionar ? 2 : 5} style={{ alignItems: "end", display: "flex" }}>
                        <Form.Item style={{ width: "100%" }}>
                            <Button
                                type="primary"
                                id={Tutoriais.IDs.botaoListar}
                                htmlType="submit"
                                disabled={listaEmpresas.isFetching}
                                style={{ width: "100%" }}
                            >
                                Listar
                            </Button>
                        </Form.Item>
                    </Col>

                    <Restrito aberto={adicionar}>
                        <Col xs={12} xl={3} id={Tutoriais.IDs.botaoAdicionar} style={{ alignItems: "end", display: "flex" }}>
                            <Form.Item style={{ width: "100%" }}>
                                <Link
                                    to={props.hrefDoBotaoAdicionar ?? "#"}
                                    onClick={(e) => {
                                        !props.hrefDoBotaoAdicionar && e.preventDefault();
                                    }}
                                >
                                    <Button
                                        type="primary"
                                        onClick={() => {
                                            props.aoAdicionar?.();
                                        }}
                                        style={{ width: "100%" }}
                                    >
                                        Adicionar
                                    </Button>
                                </Link>
                            </Form.Item>
                        </Col>
                    </Restrito>
                </Row>
            </Form>

            <Row>
                <Col xs={24}>
                    <ResponsiveAntdTable<TypeEmpresa>
                        bordered
                        locale={{ emptyText: "Nenhuma empresa encontrada." }}
                        dataSource={listaEmpresas.data?.data}
                        loading={listaEmpresas.isFetching}
                        rowKey={(k) => k.codigo!}
                        addTitleOn="lg"
                        expandable={{
                            showExpandColumn: false,
                            expandedRowRender: (record) => <div>{JSON.stringify(record)}</div>,
                            rowExpandable: () => true,
                            expandedRowKeys: chavesDasLinhasExpandidas,
                        }}
                        columns={[
                            {
                                title: "Código",
                                breakpoints: { xs: 12, sm: 12, lg: 2 },
                                dataIndex: "codigo",
                                sorter: (a, b) => Ordenar.Numero(a.codigo, b.codigo),
                                key: "codigo",
                            },
                            {
                                title: "Ativo",
                                dataIndex: ["ativo"],
                                breakpoints: { xs: 12, sm: 12, lg: 2 },
                                key: "ativo",
                                sorter: (a, b) => Ordenar.Booleano(a.ativo, b.ativo),
                                render: (v: boolean) => {
                                    return <>{v ? "Sim" : "Não"}</>;
                                },
                            },
                            {
                                title: "Razão social",
                                breakpoints: { xs: 8, sm: 8, lg: 6 },
                                dataIndex: ["nome"],
                                sorter: (a, b) => Ordenar.String(a.nome, b.nome),
                                key: "nome",
                            },
                            {
                                title: "Nome fantasia",
                                breakpoints: { xs: 8, sm: 8, lg: 5 },
                                dataIndex: ["nomeSocial"],
                                sorter: (a, b) => Ordenar.String(a.nomeSocial, b.nomeSocial),
                                key: "nome-social",
                            },
                            {
                                title: "CNPJ",
                                breakpoints: { xs: 8, sm: 8, lg: 4 },
                                dataIndex: ["cnpj"],
                                sorter: (a, b) => Ordenar.String(a.cnpj, b.cnpj),
                                render: (val) => Formatacoes.formatarCNPJ(val),
                                key: "cnpj",
                            },

                            {
                                title: "Ações",
                                key: "acoes",
                                noResponsiveTitle: true,
                                breakpoints: { xs: 24, sm: 24, lg: 5 },
                                hidden: [Permissoes.AtualizarEmpresa, Permissoes.DesativarEmpresa, Permissoes.AtivarEmpresa].every(
                                    (p) => !permissoes?.includes(p)
                                ),
                                render: (_, item) => {
                                    return (
                                        <Conjunto
                                            style={{ justifyContent: tamanhoDaTela.sm ? "unset" : "center", display: "flex", flexWrap: "wrap" }}
                                            itens={[
                                                <Button
                                                    type="dashed"
                                                    size="small"
                                                    icon={item.codigo && chavesDasLinhasExpandidas.includes(item.codigo) ? <MinusOutlined /> : <PlusOutlined />}
                                                    onClick={() => {
                                                        if (!item.codigo) return;

                                                        if (chavesDasLinhasExpandidas.includes(item.codigo)) {
                                                            setChavesDasLinhasExpandidas((prev) => prev.filter((v) => v != item.codigo));
                                                        } else {
                                                            setChavesDasLinhasExpandidas((prev) => [...prev, item.codigo!]);
                                                        }
                                                    }}
                                                ></Button>,
                                                <EmpresaFaturamentoDrawerForm
                                                    codPessoa={item.codigo!}
                                                    elementoGatilho={
                                                        <Button type="dashed" size="small">
                                                            Config. faturamento
                                                        </Button>
                                                    }
                                                />,
                                                ...(() => {
                                                    if (item.ativo) {
                                                        return [
                                                            permissoes?.includes(Permissoes.AtualizarEmpresa) && (
                                                                <Link
                                                                    to={props.hrefDoBotaoEditar?.(item) ?? "#"}
                                                                    onClick={(e) => !props.hrefDoBotaoEditar && e.preventDefault()}
                                                                >
                                                                    <Button
                                                                        className={Tutoriais.Classes.botaoEditar}
                                                                        type="primary"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            props.aoEditar?.(item);
                                                                        }}
                                                                    >
                                                                        Editar
                                                                    </Button>
                                                                </Link>
                                                            ),

                                                            permissoes?.includes(Permissoes.DesativarEmpresa) && (
                                                                <Popconfirm
                                                                    {...PropriedadesDoPopConfirm("desativar")}
                                                                    onConfirm={() => {
                                                                        item.codigo &&
                                                                            empresaService
                                                                                .desativar(item.codigo)
                                                                                .then(() => {
                                                                                    listaEmpresas.refetch();
                                                                                })
                                                                                .catch(() => {});
                                                                    }}
                                                                >
                                                                    <Button type="default" danger size="small" id={Tutoriais.Classes.botaoDesativar}>
                                                                        Desativar
                                                                    </Button>
                                                                </Popconfirm>
                                                            ),
                                                        ];
                                                    } else {
                                                        return [
                                                            permissoes?.includes(Permissoes.AtivarEmpresa) && (
                                                                <Popconfirm
                                                                    {...PropriedadesDoPopConfirm("ativar")}
                                                                    onConfirm={() => {
                                                                        item.codigo &&
                                                                            empresaService
                                                                                .ativar(item.codigo)
                                                                                .then(() => {
                                                                                    listaEmpresas.refetch();
                                                                                })
                                                                                .catch(() => {});
                                                                    }}
                                                                >
                                                                    <Button type="dashed" size="small">
                                                                        Reativar
                                                                    </Button>
                                                                </Popconfirm>
                                                            ),
                                                        ];
                                                    }
                                                })(),
                                            ]}
                                        />
                                    );
                                },
                            },
                        ]}
                        
                        csv={{
                            enabled: true,
                            filename: "empresas.csv",
                        }}
                    />
                </Col>
            </Row>

            <AdicionarAjuda
                tutoriais={
                    [
                        {
                            titulo: "Como consultar empresas",
                            tutorial: Tutoriais.ConsultarEmpresa,
                        },

                        permissoes?.includes(Permissoes.CriarEmpresa) && {
                            titulo: "Como cadastrar uma nova empresa",
                            tutorial: Tutoriais.AdicionarEmpresa,
                        },

                        permissoes?.includes(Permissoes.AtualizarEmpresa) && {
                            titulo: "Como editar uma empresa",
                            tutorial: Tutoriais.EditarEmpresa,
                        },

                        permissoes?.includes(Permissoes.DesativarEmpresa) && {
                            titulo: "Como desativar uma empresa",
                            tutorial: Tutoriais.DesativarEmpresa,
                        },
                    ].filter((v) => v != false) as ITutorial[]
                }
            />
        </>
    );
}

const CadastroDeEmpresa: React.FC<{
    empresaEmAlteracao?: TypeEmpresa

    aoCancelar?: () => any,
    depoisDeFinalizar?: () => any,
}> = (props) => {

    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);
    const [passoAtual, setPassoAtual] = useState(0);

    const [empresa, setEmpresa] = useState<TypeEmpresa>(props.empresaEmAlteracao ?? {});

    const [enderecos, setEnderecos] = useState<TypeEndereco[]>(props.empresaEmAlteracao?.enderecos ?? []);
    const [telefones, setTelefones] = useState<TypeTelefone[]>(empresa?.telefones ?? []);
    const [emails, setEmails] = useState<TypeEmail[]>(props.empresaEmAlteracao?.emails ?? []);

    useEffect(() => {
        setEmpresa((prev) => ({ ...prev, enderecos: enderecos }))
    }, [enderecos])

    useEffect(() => {
        setEmpresa((prev) => ({ ...prev, telefones: telefones }))
    }, [telefones])

    useEffect(() => {
        setEmpresa((prev) => ({ ...prev, emails: emails }))
    }, [emails])

    const inserePessoa = useMutation({
        mutationFn: (empresaParam: TypePessoa) => empresaService.inserir(empresaParam),
        onSuccess: () => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso( 'Cadastro realizado com sucesso.')
            })

            props.depoisDeFinalizar?.();
        },
    })

    const atualizaPessoa = useMutation({
        mutationFn: (empresaParam: TypePessoa) => empresaService.atualizar(empresaParam),
        onSuccess: () => {
            notification.open({
                ...PropriedadesDeNotificacao.Sucesso('Cadastro atualizado com sucesso.')
            })

            props.depoisDeFinalizar?.();
        },
    })

    const proximoPasso = () => {
        const passo = passoAtual + 1

        if (passo < passos.length) {
            setPassoAtual(passo)
        }
    }

    const passoAnterior = () => {
        const passo = (passoAtual - 1)
        if (passo >= 0) {
            setPassoAtual(passo)
        } else {
            props?.aoCancelar?.()
        }
    }

    const [formBasico] = useForm()
    const passos = [
        {
            title: 'Dados Básicos',
            icon: <FileTextOutlined />,
            conteudo: <React.Fragment>
                <FormularioDeDadosBasicosDaEmpresa dadosIniciais={empresa} form={formBasico}
                    depoisDeSubmeter={(empresa) => {
                        setEmpresa((prev) => ({ ...prev, ...empresa }));
                        proximoPasso();
                    }}
                />
                <Row>
                    <Col xs={24}>
                        <div style={{ textAlign: 'center', marginTop: 24 }}>
                            <Button danger type="primary" style={{ margin: '0 8px' }} onClick={() => passoAnterior()}>
                                Cancelar
                            </Button>
                            <Button type="primary" key="submit" onClick={() => { formBasico.submit(); }} >
                                Avançar
                            </Button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>,
            style: {
                fontWeight: 600
            }
        },
        {
            title: 'Endereços',
            icon: <EnvironmentOutlined />,
            conteudo: <React.Fragment>
                <FormularioDeEnderecos permitirEdicaoDosEnderecos enderecosAPI={[enderecos, setEnderecos]} distancia={false} />
                <Row>
                    <Col xs={24}>
                        <div style={{ textAlign: 'center', marginTop: 24 }}>
                            <Button danger type="primary" style={{ margin: '0 8px' }} onClick={() => passoAnterior()}>
                                Voltar
                            </Button>
                            <Button type='primary' onClick={() => {
                                if (enderecos.filter(f => f.ativo !== false).length > 0) {
                                    setEmpresa({
                                        ...empresa!,
                                        enderecos: enderecos
                                    })
                                    proximoPasso()
                                }
                                else {
                                    message.destroy();
                                    message.open({
                                        type: 'warning',
                                        content: 'Adicione ao menos um endereço antes de avançar.'
                                    })
                                }
                            }
                            }>
                                Avançar
                            </Button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>,
            style: {
                fontWeight: 600
            }
        },
        {
            title: 'Contatos',
            icon: <PhoneOutlined />,
            conteudo: <React.Fragment>
                <FormularioDeContatos telefonesAPI={[telefones, setTelefones]} emailsAPI={[emails, setEmails]} />
                <Row>
                    <Col xs={24}>
                        <div style={{ textAlign: 'center', marginTop: 24 }}>
                            <Button danger type="primary" style={{ margin: '0 8px' }} onClick={() => passoAnterior()}>
                                Voltar
                            </Button>
                            <Button type="primary"
                                disabled={!permissoes?.includes(props.empresaEmAlteracao != undefined ? Permissoes.AtualizarEmpresa : Permissoes.CriarEmpresa)}
                                onClick={() => {
                                    message.destroy();
                                    if (!empresa?.telefones || empresa.telefones.length == 0)
                                        message.open({
                                            type: 'warning',
                                            content: 'Adicione ao menos um telefone antes de salvar.'
                                        })
                                    else if (!empresa?.emails || empresa.emails.length == 0)
                                        message.open({
                                            type: 'warning',
                                            content: 'Adicione ao menos um endereço de e-mail antes de salvar.'
                                        })
                                    else {
                                        if (empresa.codigo === undefined) {
                                            inserePessoa.mutate({
                                                ...empresa,
                                                enderecos: empresa.enderecos?.map((e) => ({ ...e, codigo: undefined })),
                                                emails: empresa.emails?.map((e) => ({ ...e, codigo: undefined })),
                                                telefones: empresa.telefones?.map((t) => ({ ...t, codigo: undefined }))
                                            })
                                        }
                                        else {
                                            atualizaPessoa.mutate({
                                                ...empresa,
                                                enderecos: empresa.enderecos?.map((e) => e.codigo && e.codigo < 0 ? ({ ...e, codigo: undefined }) : e),
                                                emails: empresa.emails.map((em) => em.codigo && em.codigo < 0 ? ({ ...em, codigo: undefined }) : em),
                                                telefones: empresa.telefones.map((tel) => tel.codigo && tel.codigo < 0 ? ({ ...tel, codigo: undefined }) : tel)
                                            });
                                        }
                                    }

                                }
                                }>
                                Salvar
                            </Button>
                        </div>
                    </Col>
                </Row>
            </React.Fragment>,
            style: {
                fontWeight: 600
            }
        },
    ]

    return (
        <>
            <Steps
                current={passoAtual}
                items={passos.map((m) => ({
                    title: m.title,
                    icon: m.icon,
                    style: m.style
                }))}
            />
            <div style={{ marginTop: 15 }}>
                {passos[passoAtual].conteudo}
            </div>
        </>
    )

}

export const Empresa: React.FC<{}> = (props) => {
    const [empresaEmAlteracao, setEmpresaEmAlteracao] = useState<TypeEmpresa | undefined>(undefined);
    const permissoes = useContext(SessaoContext)?.sessao?.usuario?.permissoes.map((p) => p.nome);

    const navigate = useNavigate();
    const [raiz, subrota] = useRelativePath();

    const rotaDeEdicao = matchPath({ path: "/editar" }, subrota);
    const rotaDeVisualizacao = matchPath({ path: "/detalhes" }, subrota);

    const obterEmpresa = useMutation({
        mutationFn: (id: number) => new EmpresaService().listar({ codigo: id, ativo: true }),
        gcTime: 0,
        onSuccess: (resposta) => {
            const resultados = resposta.data;
            if (resultados.length == 0) {
                notification.open({
                    ...PropriedadesDeNotificacao.Erro("Nenhum registro foi encontrado para o identificador informado")
                })
                navigate(raiz)
            } else {
                setEmpresaEmAlteracao(resposta.data.at(0))
            }
        }
    })

    useRedirection([Permissoes.ListarEmpresas, Permissoes.CriarEmpresa, Permissoes.AtualizarEmpresa, Permissoes.DesativarEmpresa])
    useWatchParameterOnRoutes({
        appliablePaths: [rotaDeEdicao, rotaDeVisualizacao], paramToWatch: "id", filters: [(p) => isNaN(Number(p))],
        onNotAccepted() { navigate(raiz) },
        onExists(param) { obterEmpresa.mutate(Number(param)); },
    })

    return (
        <>
            <h2 style={{ marginTop: 0 }}>
                {
                    rotaDeVisualizacao ? "Detalhes da Empresa" : rotaDeEdicao ? "Edição da Empresa" : "Cadastro de Empresa"
                }
            </h2>

            <Divider />

            <Routes>
                {
                    permissoes?.includes(Permissoes.ListarEmpresas) &&
                    <Route path="*" index element={
                        <ListagemDeEmpresas
                            hrefDoBotaoAdicionar={raiz + "/cadastro"}
                            hrefDoBotaoEditar={(item) => {
                                if (item.codigo) {
                                    return raiz + `/editar?id=${item.codigo}`
                                }
                            }}

                            aoEditar={(empresa) => {
                                setEmpresaEmAlteracao(empresa)
                            }}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.CriarEmpresa) &&
                    <Route path="/cadastro" element={
                        <CadastroDeEmpresa
                            aoCancelar={() => { navigate(raiz) }}
                            depoisDeFinalizar={() => { navigate(raiz) }}
                        />
                    } />
                }

                {
                    permissoes?.includes(Permissoes.AtualizarEmpresa) &&
                    <Route path="/editar" element={
                        empresaEmAlteracao == undefined ? <Skeleton active /> :
                            <CadastroDeEmpresa
                                empresaEmAlteracao={empresaEmAlteracao}
                                aoCancelar={() => { navigate(raiz) }}
                                depoisDeFinalizar={() => { navigate(raiz) }}
                            />
                    } />
                }
            </Routes>

        </>
    );
}